import ytIconRed from "../../assets/images/brands/youtube/yt_icon_red.png";
import ytIconAlmostBlack from "../../assets/images/brands/youtube/yt_icon_almostblack.png";
import ytIconWhite from "../../assets/images/brands/youtube/yt_icon_white.png";

// Official YouTube icon asset from YouTube Brand Resources (Digital kit).
// Per YouTube API Services Branding Guidelines (Policy III.F.2):
//   - minimum height: 20dp
//   - colors cannot be modified — use only the three official variants
//   - clear space ≥ width of the triangle (~18% of icon width)
// Do NOT wrap this in a colored container or apply CSS color/filter.

const VARIANTS = {
  red: ytIconRed,
  almostblack: ytIconAlmostBlack,
  white: ytIconWhite,
};

const MIN_HEIGHT = 20;

const YoutubeIcon = ({ height = 24, variant = "red", className, style }) => {
  const h = Math.max(MIN_HEIGHT, height);
  return (
    <img
      src={VARIANTS[variant] ?? ytIconRed}
      alt="YouTube"
      className={className}
      draggable={false}
      style={{
        height: h,
        width: "auto",
        display: "inline-block",
        verticalAlign: "middle",
        flexShrink: 0,
        ...style,
      }}
    />
  );
};

export default YoutubeIcon;
